<template>
  <!-- Keep top header bar -->
  <div class="nav-bar-operations">
    <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" />
  </div>

  <main class="page">
    <header class="page-header">
      <div class="titles">
        <h2>Visor de comisiones</h2>
        <p class="subtitle">Semana de nómina en curso, de martes a lunes.</p>
      </div>

      <div class="user-actions">
        <div class="welcome">
          <span class="chip">👤</span>
          <div class="welcome-text">
            <div class="welcome-label">Bienvenido/a</div>
            <div class="welcome-name">{{ firstName }}</div>
          </div>
        </div>

        <div class="action-buttons">
          <button class="btn btn-ghost" @click="goBack">Regresar</button>
          <button class="btn btn-danger" @click="logout">Cerrar sesión</button>
        </div>
      </div>
    </header>

    <!-- Filters -->
    <form class="filters-card" @submit.prevent="queryOrders">
      <div class="filters-grid">
        <div class="field">
          <label>Semana de nómina</label>
          <div class="date-range">
            <input
  type="date"
  v-model="startDate"
  :min="minAllowedDate"
  :max="maxAllowedDate"
  :disabled="true"
  class="grayed-out"
/>

<span class="sep">al</span>

<input
  type="date"
  v-model="endDate"
  :min="minAllowedDate"
  :max="maxAllowedDate"
  :disabled="true"
  class="grayed-out"
/>
          </div>
        </div>

        <div class="filters-actions">
          <button type="submit" class="btn btn-primary" @click="queryOrders">
            Buscar
          </button>
        </div>
      </div>
    </form>

    <!-- Results -->
    <section class="card">
      <div class="card-header">
        <div>
          <h3>Resultados</h3>
          <p class="muted">
            Mostrando {{ paginatedOrders.length }} de {{ assignations.length }} asignaciones
          </p>
        </div>

        <div class="pager inline-pager">
          <button class="icon-btn" @click="prevPage" :disabled="currentPage === 1" aria-label="Página anterior">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
          <span class="pager-label">Página <b>{{ currentPage }}</b> de <b>{{ totalPages }}</b></span>
          <button class="icon-btn" @click="nextPage" :disabled="currentPage >= totalPages" aria-label="Página siguiente">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
      </div>

      <!-- Desktop / tablet table -->
      <div class="table-wrap">
        <table class="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Fecha</th>
              <th class="right">Comisión</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(assignation, index) in paginatedOrders" :key="index">
              <td>
                <span class="id-pill">{{ assignation.assistance_note.note_number }}</span>
              </td>
              <td class="mono">{{ assignation.assistance_note.request_time.substring(8,10) }}/{{ assignation.assistance_note.request_time.substring(5,7) }}/{{ assignation.assistance_note.request_time.substring(0,4) }}</td>

              <td class="right money">
                ${{ Number(assignation.commission) * (Number(assignation.operator.employee_commission_percentage)/100) }}
              </td>
            </tr>

            <tr v-if="paginatedOrders.length === 0">
              <td colspan="6" class="empty">
                No hay resultados para este rango.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile cards -->
      <div class="mobile-list">
        <article class="mobile-item" v-for="(assignation, index) in paginatedOrders" :key="'m'+index">
          <div class="mobile-top">
            <div class="left">
              <span class="id-pill">{{ assignation.assistance_note.note_number }}</span>
            </div>
            <div class="right-col">
              <div class="money">
                Comision: ${{ Number(assignation.commission) * (Number(assignation.operator.employee_commission_percentage)/100) }}
              </div>
              <div class="mono muted">{{ assignation.assistance_note.request_time.substring(8,10) }}/{{ assignation.assistance_note.request_time.substring(5,7) }}/{{ assignation.assistance_note.request_time.substring(0,4) }}</div>
            </div>
          </div>

          <div class="mobile-grid">

          </div>
        </article>

        <div v-if="paginatedOrders.length === 0" class="mobile-empty">
          No hay resultados para este rango.
        </div>
      </div>

      <!-- Totals summary -->
<div class="totals-bar">
  <div class="totals-item">
    <span class="label">Total de servicios</span>
    <span class="value">{{ totalServices }}</span>
  </div>

  <div class="totals-item highlight">
    <span class="label">Total comisión</span>
    <span class="value">
      {{ totalCommission.toFixed(2) }}
    </span>
  </div>
</div>

      <!-- Sticky pager for mobile -->
      <div class="pager sticky-pager">
        <button class="icon-btn" @click="prevPage" :disabled="currentPage === 1" aria-label="Página anterior">
          <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
        </button>
        <span class="pager-label">Página <b>{{ currentPage }}</b> de <b>{{ totalPages }}</b></span>
        <button class="icon-btn" @click="nextPage" :disabled="currentPage >= totalPages" aria-label="Página siguiente">
          <img src="@/assets/angulo-derecho.png" alt="Next Page" />
        </button>
      </div>


    </section>
  </main>
</template>

<style scoped>
/* ===== Light theme tokens ===== */
:root{
  --bg: #f6f7f9;
  --surface: #ffffff;
  --surface-2: #fbfbfc;
  --border: #e3e6ea;
  --text: #1f2937;
  --muted: #6b7280;
  --shadow: 0 10px 25px rgba(0,0,0,.08);
  --radius: 16px;
  --radius-sm: 12px;

  --brand: #FFC434;
  --brand-2: rgba(255,196,52,.22);

  --danger: #e53935;
}

/* ===== Base reset ===== */
*{ box-sizing: border-box; }
html, body{ height: 100%; }
body{
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial;
}

/* ===== Keep your header bar ===== */
.nav-bar-operations{
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 64px;
  background-color: var(--brand);
  z-index: 1000;
}
.logo-button{
  position: absolute;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  margin: 0;
}

/* ===== Page layout ===== */
.page{
  padding: 86px 12px 18px; /* space for fixed top bar */
  max-width: 1200px;
  margin: 0 auto;
}

.page-header{
  display: grid;
  gap: 12px;
  margin-bottom: 12px;
}

.titles h2{
  margin: 0;
  font-size: 22px;
  letter-spacing: .2px;
  font-weight: 900;
}
.subtitle{
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 13px;
}

/* ===== Welcome + buttons row ===== */
.user-actions{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.welcome{
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.chip{
  width: 34px; height: 34px;
  display: grid; place-items: center;
  border-radius: 12px;
  background: var(--brand-2);
  color: var(--text);
  font-size: 16px;
}
.welcome-text{ line-height: 1.1; }
.welcome-label{ font-size: 11px; color: var(--muted); }
.welcome-name{ font-size: 14px; font-weight: 800; }

.action-buttons{
  display: flex;
  gap: 8px;
}

/* ===== Buttons ===== */
.btn{
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  padding: 10px 12px;
  border-radius: 14px;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  transition: transform .06s ease, background .15s ease, border-color .15s ease, opacity .15s ease;
}
.btn:hover{ background: var(--surface-2); }
.btn:active{ transform: translateY(1px); }
.btn:disabled{ opacity: .5; cursor: not-allowed; }

.btn-primary{
  background: linear-gradient(180deg, #FFD36B 0%, #FFC434 100%);
  border-color: rgba(0,0,0,.12);
  color: #151515;
  box-shadow: 0 10px 20px rgba(255,196,52,.20);
}
.btn-ghost{
  background: transparent;
}
.btn-danger{
  background: rgba(229,57,53,.10);
  border-color: rgba(229,57,53,.28);
  color: #b42318;
}

/* ===== Cards ===== */
.card, .filters-card{
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.card{
  overflow: hidden;
}

.card-header{
  padding: 12px 12px 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--border);
  background: #ffffff;
}

.card-header h3{
  margin: 0;
  font-size: 15px;
  font-weight: 900;
}

.muted{ color: var(--muted); }
.mono{ font-variant-numeric: tabular-nums; }

/* ===== Filters ===== */
.filters-card{
  padding: 12px;
  margin-bottom: 12px;
}

.filters-grid{
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: end;
}

.field label{
  display: block;
  font-size: 12px;
  color: var(--muted);
  margin-bottom: 6px;
}

.date-range{
  display: grid;
  grid-template-columns: 1fr 24px 1fr;
  gap: 8px;
  align-items: center;
}

.sep{
  text-align: center;
  color: var(--muted);
  font-size: 12px;
}

.filters-card input[type="date"]{
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d7dbe0;
  border-radius: 14px;
  font-size: 13px;
  outline: none;
  background: #fff;
  color: var(--text);
}

.filters-card input[type="date"]:focus{
  border-color: rgba(255,196,52,.9);
  box-shadow: 0 0 0 3px rgba(255,196,52,.22);
}

.grayed-out{ opacity: .6; }

/* ===== Table ===== */
.table-wrap{
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table{
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 520px; /* keep columns stable on tablets; scroll if needed */
}

.table thead th{
  position: sticky;
  top: 0;
  background: #f3f4f6;
  text-align: left;
  font-size: 12px;
  letter-spacing: .3px;
  color: var(--muted);
  padding: 12px;
  border-bottom: 1px solid var(--border);
}

.table tbody td{
  padding: 12px;
  border-bottom: 1px solid rgba(227,230,234,.9);
  vertical-align: top;
  font-size: 13px;
  color: var(--text);
}

.table tbody tr:hover td{
  background: #fafafa;
}

.right{ text-align: right; }
.money{ font-weight: 900; }

.addr b{ color: #111827; }
.addr div{ margin: 0 0 2px; }

.id-pill{
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255,196,52,.26);
  border: 1px solid rgba(255,196,52,.35);
  color: #111827;
  font-weight: 900;
  letter-spacing: .2px;
}

.badge{
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  color: #111827;
}

.empty{
  padding: 18px 12px;
  color: var(--muted);
  text-align: center;
}

/* ===== Pagination (THIS fixes the “giant buttons”) ===== */
.pager{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
}

.inline-pager{
  padding: 0;
  border: 0;
  background: transparent;
}

.pager-label{
  font-size: 13px;
  color: var(--muted);
  white-space: nowrap;
}

/* Button size is fixed here — prevents giant/stretching */
.icon-btn{
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid var(--border);
  background: var(--surface);
  cursor: pointer;
  display: grid;
  place-items: center;
  padding: 0;
  flex: 0 0 auto; /* IMPORTANT: stops flex from stretching */
}

.icon-btn:disabled{
  opacity: .45;
  cursor: not-allowed;
}

/* IMPORTANT: constrain the arrow image */
.icon-btn img{
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: block;
}

/* Sticky pager for mobile */
.sticky-pager{
  position: sticky;
  bottom: 10px;
  margin: 10px 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: rgba(255,255,255,.92);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow);
}

/* ===== Mobile cards ===== */
.mobile-list{ display: none; }

/* ===== Responsive tweaks ===== */
@media (max-width: 820px){
  .filters-grid{
    grid-template-columns: 1fr;
  }
  .filters-actions .btn{
    width: 100%;
  }
}

@media (max-width: 700px){
  .table-wrap{ display: none; }
  .inline-pager{ display: none; } /* use sticky pager instead */

  .mobile-list{
    display: grid;
    gap: 10px;
    padding: 12px;
  }

  .mobile-item{
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: #ffffff;
    padding: 12px;
    box-shadow: var(--shadow);
  }

  .mobile-top{
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .mobile-top .left{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  .right-col{
    text-align: right;
    min-width: 120px;
  }

  .mobile-grid{
    display: grid;
    gap: 10px;
  }

  .mobile-block .label{
    font-size: 12px;
    color: var(--muted);
    margin-bottom: 6px;
  }

  .mobile-empty{
    padding: 14px;
    text-align: center;
    color: var(--muted);
  }
}

/* =======================
   TOTALS BAR
   ======================= */
.totals-bar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  margin: 12px;
  background: #ffffff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.totals-item{
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.totals-item .label{
  font-size: 12px;
  color: var(--muted);
}

.totals-item .value{
  font-size: 18px;
  font-weight: 900;
  color: var(--text);
}

.totals-item.highlight .value{
  color: #111827;
}

/* Mobile: stack totals */
@media (max-width: 600px){
  .totals-bar{
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
}

.grayed-out{
  opacity: .65;
  cursor: not-allowed;
}

.filters-card input[disabled]{
  background: #f3f4f6 !important;
  color: #6b7280 !important;
}
</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      assignations: [],
      username: '',
      firstName: '',
      lastName: '',
      startDate: '',
      endDate: '',
       minAllowedDate: '',
  maxAllowedDate: '',
    };
  },
  computed: {
    paginatedOrders() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.assignations.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.assignations.length / this.pageSize);
    },
    totalServices() {
    return this.assignations.length;
  },
  totalCommission() {
    return this.assignations.reduce((sum, a) => {
      const commission =
        Number(a.commission) *
        (Number(a.operator.employee_commission_percentage) / 100);
      return sum + commission;
    }, 0);
  }
  },
  mounted() {
    this.fetchCurrentUser();
    this.loadCommissionWeek();
    this.queryOrders();
  },
  methods:{
    toggleFilterMenu() {
      this.showFilterMenu = !this.showFilterMenu;
    },
    applyFilters() {
      console.log('Filtros aplicados:', this.selectedFilters);
      this.showFilterMenu = false;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    async queryOrders() {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.post(`${apiDirectory}/get-assignations-operator-all`, {}, {
          headers: {
            'Authorization': `Token ${localStorage.getItem('authToken')}`
          }
        });
        // Order comes from the server: request date descending, then id.
        this.assignations = response.data
          .filter(assignation => assignation.assistance_note !== null && assignation.assistance_note.note_number != null);
      } catch (error) {
        console.error('Failed to fetch assignations:', error);
      }
    },
    navigateToOrderDetails(assignation_id) {
      this.$router.push({ name: 'EditAssignation', params: { assignation_id } });
    },
    fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY;
      axios.get(`${apiDirectory}/current-user/`, {
        headers: {
          'Authorization': 'Token ' + localStorage.getItem('authToken')
        }
      })
      .then(response => {
        this.username = response.data.username;
        this.firstName = response.data.first_name;
        this.lastName = response.data.last_name;
        this.groups = response.data.groups;
      })
      .catch(error => {
        console.error('There was an error fetching the user data:', error);
      });
    },
    logout() {
      // Also flush the Django session cookie (OAuth consent flow).
      axios.post(`${process.env.API_DIRECTORY}/logout/`).catch(() => {});
      this.$store.commit('setToken', null);
      localStorage.removeItem('authToken');
      this.$router.push({ name: 'UserLogin' });
    },
    goBack() {
      this.$router.push({ name: 'OperatorInterface' });
    },
    async loadCommissionWeek() {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/mobile/operator/commissions/weeks/`, {
          headers: {
            'Authorization': `Token ${localStorage.getItem('authToken')}`
          }
        });
        const week = (response.data.weeks || [])[0];
        if (!week) return;
        this.startDate = week.start_date;
        this.endDate = week.end_date;
        this.minAllowedDate = week.start_date;
        this.maxAllowedDate = week.end_date;
      } catch (error) {
        console.error('Failed to fetch commission week:', error);
      }
    },
  }
}
</script>